// Default:
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// Utils:
import store from "./store.js";
import getInfoTable from "@/util/infoTable.js";
import scrollBehavior from "@/util/scrollBehavior.js";
import permissions from "@/util/permissions.js";
// Pages routers:
import {
  company,
  downloads,
  rules,
  responsibleGaming,
} from "@/views/pages/routers.js"; // Institucional - Children Routers

// 'Dashboard User' routers:
import RoutersUser from "./views/dashboard/user/router.config.js"; // Dashboard - Children Routers
// 'Dashboard Agent' routers:
import RoutersAgent from "./views/dashboard/agent/router.config.js"; // Dashboard - Children Routers
import messages from "./languages/index.js";

let lang = localStorage.getItem("language") || store.state.language;
let translate = {
  pt: "Futebol",
  es: "Fútbol",
  en: "Soccer",
  null: "Futebol",
};

let myPromotionsTranslation = {
  pt: "Minhas Promoções",
  en: "My Promotions",
  es: "Mis Promociones",
};

let promotionsTranslation = {
  pt: "Promoções",
  en: "Promotions",
  es: "Promociones",
};

// let liveCasinoTranslation = {
// pt: "Cassino ao Vivo",
// en: "Live Casino",
// };

const getMainPage = () => {
  if (store.state.operators.home_page === "casino") {
    return "casinoHome";
  }

  return "bigTable";
};

const router = new VueRouter({
  mode: "history",
  scrollBehavior,
  routes: [
    // Home
    {
      path: "/",
      name: "main",
      redirect: {
        name: getMainPage(),
      },
      component: () =>
        new Promise((resolve) => {
          async function executeAsync() {
            localStorage.setItem("reloadInfoTable", false);
            let isExist = false;
            const result = await getInfoTable(isExist);
            if (result) {
              resolve(import("./views/home/"));
            }
          }

          if (store.state.operators.operator_id) {
            localStorage.setItem("reloadInfoTable", true);
            resolve(import("./views/home/"));
          } else {
            executeAsync();
          }
        }),
      children: [
        // Deposit
        {
          path: "deposit",
          name: "depositDialog",
        },
        // Share Bet Ticket
        {
          path: "bet/:bet_id",
          name: "BetCreationFromId",
        },

        {
          path: "open-register-dialog",
          name: "OpenRegisterDialog",
        },

        // =================================== //
        // Big Table                           //
        // =================================== //
        {
          path: "/bt",
          name: "bigTable",
          component: () => import("./views/home/big-table"),
          beforeEnter: function(to, from, next) {
            if (!Vue.prototype.$isAgent() && !permissions().bigTable) {
              const goToSports = {
                name: "Sports",
                query: {
                  sport: translate[lang],
                  live: translate[lang],
                },
              };

              if (to.query.loginExemptPlayer) {
                goToSports.query.loginExemptPlayer = to.query.loginExemptPlayer;
              }

              next(goToSports);
            }

            if (Vue.prototype.$isAgent()) {
              if (
                store.state.logged.data &&
                store.state.logged.data.is_afilliate == "1"
              ) {
                next({
                  name: "AgentDashboard",
                });

                return;
              }
            }

            next();
          },
          children: [
            {
              name: "btEvent",
              path: ":sport/:category/:tournament/:event",
              component: () => import("./views/home/sports/events"),
            },
            {
              name: "DepositSuccessBt",
              path: "deposit/success",
            },
            {
              name: "RegisterSuccessBt",
              path: "register/success",
            },
            {
              name: "BetSuccessBt",
              path: "bet/success",
            },
          ],
        },

        // =================================== //
        // Online Table                        //
        // =================================== //
        {
          path: "/home",
          name: "Sports",
          component: () =>
            new Promise((resolve) => {
              Vue.prototype.$isAgent()
                ? resolve(import("./views/home/big-table"))
                : resolve(import("./views/home/events"));
            }),
          beforeEnter: function(to, from, next) {
            if (permissions().bigTable) {
              next({
                name: "bigTable",
              });
            }

            if (Vue.prototype.$isAgent()) {
              if (
                store.state.logged.data &&
                store.state.logged.data.is_afilliate == "1"
              ) {
                next({
                  name: "AgentDashboard",
                });

                return;
              }
            }

            next();
          },
          children: [
            {
              path: "conferencia/:idbet",
              name: "SportsConf",
            },
            {
              name: "DepositSuccessSports",
              path: "deposit/success",
            },
            {
              name: "RegisterSuccessSports",
              path: "register/success",
            },
            {
              name: "BetSuccessSports",
              path: "bet/success",
            },
          ],
        },
        {
          name: "live",
          path: "/live",
          // meta: { scrollToTop: true },
          component: () => import("./views/home/live/"),
          children: [
            {
              name: "eventsLive",
              path: ":sport/:category/:tournament/:event",
              component: () => import("./views/home/sports/events"),
              children: [
                {
                  name: "BetSuccessLiveEvent",
                  path: "bet/success",
                },
              ],
            },
            {
              name: "BetSuccessLive",
              path: "bet/success",
            },
          ],
        },

        // Validate Pré bet - Agent
        {
          name: "validatePreBet",
          path: "/validatePreBet",
          component: () => import("./views/home/validatePreBet/"),
          beforeEnter: function(to, from, next) {
            if (Vue.prototype.$isAgent()) {
              next();
            } else {
              next({
                name: "main",
              });
            }
          },
        },
        // Minhas apostas - Usuário Online (credit 2)
        {
          name: "myBets",
          path: "/myBets",
          redirect: {
            name: "pendentsBets",
          },
          component: () => import("./views/home/myBets/"),
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              name: "pendentsBets",
              path: "pendentsBets",
              component: () => import("./views/home/myBets/pendentsBets"),
            },
            {
              name: "closeBets",
              path: "closeBets",
              component: () => import("./views/home/myBets/closeBets"),
            },
            {
              name: "liveBets",
              path: "liveBets",
              component: () => import("./views/home/myBets/liveBets"),
            },
            {
              name: "resolvedBets",
              path: "resolvedBets",
              component: () => import("./views/home/myBets/resolvedBets"),
            },
            {
              name: "allBets",
              path: "allBets",
              component: () => import("./views/home/myBets/allBets"),
            },
            {
              name: "bonusBets",
              path: "bonusBets",
              component: () => import("./views/home/myBets/bonusBets"),
            },
          ],
          beforeEnter: function(to, from, next) {
            Vue.prototype.$isAgent()
              ? next({
                  name: "main",
                })
              : next();
          },
        },
        {
          name: "special",
          path: "special/:sport/:special",
          component: () => import("./views/home/sports/"),
          children: [
            {
              name: "eventsSpecial",
              path: ":tournament/:event",
              component: () => import("./views/home/sports/events"),
            },
          ],
        },
        {
          name: "countries",
          path: "countries/:sport/",
          component: () => import("./views/home/pages/Countries"),
          children: [
            {
              name: "eventsCountries",
              path: ":tournament/:event",
              component: () => import("./views/home/sports/events"),
              children: [
                {
                  name: "BetSuccessCountriesEvent",
                  path: "bet/success",
                },
              ],
            },
            {
              name: "BetSuccessCountries",
              path: "bet/success",
            },
          ],
        },
        {
          name: "worldCup",
          path: "worldCup",
          component: () => import("./views/home/sports/worldCup"),
          children: [
            {
              name: "eventsWorldCup",
              path: ":tournament/:event",
              component: () => import("./views/home/sports/events"),
            },
          ],
          beforeEnter: (to, from, next) => {
            const showWorldCup = ["cartola", "dasorte", "betdasorte"];

            if (
              showWorldCup.includes(Vue.prototype.$domain()) &&
              !Vue.prototype.$isAgent() &&
              store.state.sports.find((sport) => sport.id_sport == 100)
            ) {
              next();
            } else {
              next("/bt");
            }
          },
        },
        {
          name: "worldCupWinner",
          path: "worldCup/winner",
          component: () => import("./views/home/sports/worldCupWinner"),
          beforeEnter: (to, from, next) => {
            let showWorldCup = false;

            const longTermSportId = 51;
            const sports = store.state.sports;

            let hasLongTerm = false;

            if (sports) {
              if (sports.find((sport) => sport.id_sport == longTermSportId)) {
                hasLongTerm = true;
              }
            }

            if (!store.state.logged.status) {
              showWorldCup =
                Vue.prototype.$isCreditOnline() &&
                store.state.operators &&
                store.state.operators.retail == 0;
            } else {
              showWorldCup = Vue.prototype.$isCreditOnline();
            }

            if (showWorldCup && !Vue.prototype.$isAgent() && hasLongTerm) {
              next();
            } else {
              next("/bt");
            }
          },
          children: [
            {
              name: "BetSuccessWorldCupWinner",
              path: "bet/success",
            },
          ],
        },
        {
          name: "favorites",
          path: "favorites/:sport/",
          component: () => import("./views/home/sports/favorites"),
          children: [
            {
              name: "eventsFavorites",
              path: ":tournament/:event",
              component: () => import("./views/home/sports/events"),
            },
          ],
        },
        {
          name: "category",
          path: "category/:sport/:category",
          component: () => import("./views/home/sports/"),
          children: [
            {
              name: "BetSuccessEventsCategory",
              path: "bet/success",
            },
            {
              name: "eventsCategory",
              path: ":tournament/:event",
              component: () => import("./views/home/sports/events"),
              children: [
                {
                  name: "BetSuccessEventsCategoryEvent",
                  path: "bet/success",
                },
              ],
            },
          ],
        },
        {
          name: "tournament",
          path: "tournament/:sport/:category/:tournament",
          component: () => import("./views/home/sports/"),
          children: [
            {
              name: "BetSuccessTournament",
              path: "bet/success",
            },
            {
              name: "eventsTournament",
              path: ":event",
              component: () => import("./views/home/sports/events"),
              children: [
                {
                  name: "BetSuccessTournamentEvent",
                  path: "bet/success",
                },
              ],
            },
          ],
        },
        // valid register
        {
          path: "confirm-phone-change/:cod",
          name: "confirmPhoneChange",
          component: () => import("./views/confirmEmailOrPhoneChange"),
          beforeEnter: (to, from, next) => {
            localStorage.setItem("actionType", "phone");

            if (to.params && to.params.cod) {
              if (permissions().bigTable) {
                next({
                  name: "bigTable",
                  query: {
                    open_confirm_email_or_phone_change: true,
                    cod: to.params.cod,
                  },
                });
              } else {
                next({
                  name: "Sports",
                  query: {
                    sport: translate[lang],
                    live: translate[lang],
                    open_confirm_email_or_phone_change: true,
                    cod: to.params.cod,
                  },
                });
              }
            } else {
              next("/");
            }
          },
        },
        {
          path: "confirm-email-change/:cod",
          name: "confirmEmailChange",
          component: () => import("./views/confirmEmailOrPhoneChange"),
          beforeEnter: (to, from, next) => {
            localStorage.setItem("actionType", "email");

            if (to.params && to.params.cod) {
              if (permissions().bigTable) {
                next({
                  name: "bigTable",
                  query: {
                    open_confirm_email_or_phone_change: true,
                    cod: to.params.cod,
                  },
                });
              } else {
                next({
                  name: "Sports",
                  query: {
                    sport: translate[lang],
                    live: translate[lang],
                    open_confirm_email_or_phone_change: true,
                    cod: to.params.cod,
                  },
                });
              }
            } else {
              next("/");
            }
          },
        },
        {
          path: "valid-register",
          name: "valid-register",
          component: () => import("./views/valid-register/"),
          redirect: { name: "bigTable" },
        },
        {
          path: "valid-register/:cod",
          name: "new-valid-register",
          component: () => import("./views/valid-register/"),
          beforeEnter: (to, from, next) => {
            if (to.params && to.params.cod) {
              if (permissions().bigTable) {
                next({
                  name: "bigTable",
                  query: {
                    open_confirm_register: true,
                    cod: to.params.cod,
                  },
                });
              } else {
                next({
                  name: "Sports",
                  query: {
                    sport: translate[lang],
                    live: translate[lang],
                    open_confirm_register: true,
                    cod: to.params.cod,
                  },
                });
              }
            } else {
              next("/");
            }
          },
        },
        // password recover
        {
          path: "password-recover/",
          name: "password-recover",
          component: () => import("./views/password-recover/"),
          children: [
            {
              path: ":hash",
            },
          ],
        },
        // Apk - Agent
        {
          path: "apk",
          name: "apk",
        },
        // New Casino with Game Aggregator
        {
          path: "casino",
          name: "casinoHome",
          redirect: {
            // TODO Verificar se o cliente tem acesso ao casino, caso não enviar
            // para o casinoType "live"
            path: "casino/lobby/casino",
          },
          component: () => import("./views/home/casinoNew/index.vue"),
          children: [
            {
              path: "lobby/:casinoType",
              name: "casinoLobby",
              beforeEnter: async (to, from, next) => {
                if (Object.keys(store.state.operators).length === 0) {
                  await getInfoTable();
                }

                const operatorCasino = store.state.operators.casino;
                const acceptedCasinoValues = ["1", "2"];

                if (!acceptedCasinoValues.includes(operatorCasino)) {
                  next("/");
                }

                const acceptedCasinoTypes = ["casino", "live"];

                if (acceptedCasinoTypes.includes(to.params.casinoType)) {
                  if (
                    to.params.casinoType === "live" &&
                    operatorCasino !== "2"
                  ) {
                    next("/casino/lobby/casino");
                  } else {
                    next();
                  }
                } else {
                  next("/casino/lobby/casino");
                }
              },
              component: () => import("./views/home/casinoNew/lobby.vue"),
              children: [
                {
                  path: "providers",
                  name: "casinoProviders",
                  component: () =>
                    import("./views/home/casinoNew/providers.vue"),
                  children: [
                    {
                      path: ":providerId",
                      name: "casinoProvider",
                      component: () =>
                        import("./views/home/casinoNew/provider.vue"),
                      children: [
                        {
                          path: "game/:gameId",
                          name: "casinoGameProvider",
                          component: () =>
                            import(
                              "./views/home/casinoNew/components/game/index.vue"
                            ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: "favorites",
                  name: "casinoFavorites",
                  component: () =>
                    import("./views/home/casinoNew/favorites.vue"),
                  beforeEnter: function(to, from, next) {
                    if (store.state.logged.status) {
                      next();

                      return;
                    }

                    next({ name: "casinoLobby" });
                  },
                  children: [
                    {
                      path: "game/:gameId",
                      name: "casinoGameFavorites",
                      component: () =>
                        import(
                          "./views/home/casinoNew/components/game/index.vue"
                        ),
                    },
                  ],
                },
                {
                  path: "category/:category",
                  name: "casinoCategory",
                  component: () =>
                    import("./views/home/casinoNew/category.vue"),
                  children: [
                    {
                      path: "game/:gameId",
                      name: "casinoGameCategory",
                      component: () =>
                        import(
                          "./views/home/casinoNew/components/game/index.vue"
                        ),
                    },
                  ],
                },
                {
                  path: "game/:gameId",
                  name: "casinoGame",
                  component: () =>
                    import("./views/home/casinoNew/components/game/index.vue"),
                },
              ],
            },
          ],
        },
        {
          path: "casino/lobby",
          redirect: {
            // TODO Verificar se o cliente tem acesso ao casino, caso não enviar
            // para o casinoType "live"
            path: "casino/lobby/casino",
          },
        },

        // Old casino
        // Cassino
        {
          path: "casino/home",
          name: "casino",
          component: () => import("@/views/home/casino/"),
          redirect: {
            path: "casino/lobby/casino",
          },
          // beforeEnter: (to, from, next) => {
          //   if (
          //     Vue.prototype.$isAgent() ||
          //     store.state.operators.casino === "0"
          //   ) {
          //     next({ name: "main" });
          //   } else {
          //     next();
          //   }
          // },
        },
        {
          path: "casino/home",
          name: "casinoSpaceman",
          component: () => import("@/views/home/casino/"),
          redirect: {
            path: "casino/lobby/casino",
          },
          // beforeEnter: (to, from, next) => {
          //   if (
          //     Vue.prototype.$isAgent() ||
          //     store.state.operators.casino === "0"
          //   ) {
          //     next({ name: "main" });
          //   } else {
          //     next();
          //   }
          // },
        },

        // View de Casino escondida
        // {
        //   path: "superhiddenview/casino/home",
        //   name: "casino",
        //   component: () => import("@/views/home/casino/"),
        //   beforeEnter: (to, from, next) => {
        //     next();
        //   },
        // },
        {
          path: "casino/listGamesCategories/:category",
          name: "ListGamesCategories",
          component: () => import("@/views/home/casino/ListGamesCategories"),
          redirect: {
            path: "casino/lobby/casino",
          },
        },
        {
          path: "casino/game/:gameID/:isFreeGame",
          name: "casino-game",
          component: () => import("@/views/home/casino/game"),
          redirect: {
            path: "casino/lobby/casino",
          },
          // props: (route) => ({
          //   ...route.params,
          // }),
          // beforeEnter: function(to, from, next) {
          //   store.state.logged.status
          //     ? next()
          //     : next({
          //         name: "casino",
          //         params: {
          //           openLoginDialog: true,
          //           redirectedGameName: to.path.split("/")[3],
          //         },
          //       });
          // },
        },
        // View do LiveCasino foi substituída pela página de listagem do casino/home
        // podendo ser acessada na view ListGamesCategories
        {
          path: "casino/liveCasino",
          name: "liveCasino",
          redirect: {
            path: "casino/lobby/live",
          },
          // redirect:
          //   store.state.operators.casino == 2
          //     ? `/casino/listGamesCategories/${
          //         liveCasinoTranslation[lang || "pt"]
          //       }`
          //     : "casino/home",
          // component: () => import("@/views/home/casino/liveCasino"),
          // beforeEnter: (to, from, next) => {
          //   if (store.state.operators.casino === "0") {
          //     next({ name: "main" });
          //   } else {
          //     next();
          //   }
          // },
        },
        // PayForFun Response
        {
          path: "/p4fresponse",
          name: "p4fresponse",
        },

        {
          name: "AllPromotions",
          path: "/promotions",
          component: () => import("./views/home/promotions"),
          beforeEnter: (to, from, next) => {
            if (Vue.prototype.$isCreditOnline() && !Vue.prototype.$isAgent()) {
              next();
            } else {
              next("/");
            }
          },
        },
        {
          name: "PromotionDetail",
          path: "/promotions/:promotion_id",
          component: () => import("./views/home/promotions/detail.vue"),
          beforeEnter: (to, from, next) => {
            if (Vue.prototype.$isCreditOnline() && !Vue.prototype.$isAgent()) {
              next();
            } else {
              next("/");
            }
          },
        },
      ],
    },

    // LandingPage Register SMS
    {
      path: "/register",
      name: "register-sms",
      component: () => import("./views/sms-register/"),
    },
    // Agent Online Register New Player
    {
      path: "/player-from-agent/agent/:affiliate_id",
      name: "player-from-agent",
      component: () => import("./views/player-from-agent"),
      children: [
        {
          name: "RegisterSuccessFromAgent",
          path: "register/success",
        },
      ],
    },
    // Affiliate Online Register New Player - New Register
    {
      path: "/a/:affiliate_id",
      name: "player-register-from-affiliate",
      component: () => import("./views/player-from-agent"),
      beforeEnter: (to, from, next) => {
        if (to.params && to.params.affiliate_id) {
          localStorage.setItem("affiliateId", to.params.affiliate_id);

          next({
            name: "bigTable",
            params: {
              affiliate_id: to.params.affiliate_id,
            },
            query: {
              open_register: true,
            },
          });
        } else {
          next("/");
        }
      },
      children: [
        {
          name: "RegisterSuccessFromAffiliate",
          path: "register/success",
        },
      ],
    },

    {
      path: "/ac/:campaign_code",
      name: "player-register-from-affiliate-campaign",
      component: () => import("./views/player-from-agent"),
      beforeEnter: (to, from, next) => {
        if (to.params && to.params.campaign_code) {
          localStorage.setItem("affiliateCode", to.params.campaign_code);

          if (permissions().bigTable) {
            next({
              name: "bigTable",
              params: {
                affiliate_code: to.params.campaign_code,
              },
              query: {
                open_register: true,
                from_campaign: true,
                ...to.query,
              },
            });
          } else {
            next({
              name: "Sports",
              query: {
                sport: translate[lang],
                live: translate[lang],
                open_register: true,
                from_campaign: true,
                ...to.query,
              },
            });
          }
        } else {
          next("/");
        }
      },
      children: [
        {
          name: "RegisterSuccessFromAffiliateCampaign",
          path: "register/success",
        },
      ],
    },

    // Pages
    {
      path: "/page",
      name: "page",
      component: () => import("./views/pages"),
      children: [
        {
          name: "Register",
          path: "register",
          component: () => import("./views/pages/register.vue"),
          children: [
            {
              name: "RegisterSuccessPage",
              path: "success",
            },
          ],
        },
        {
          path: "company",
          children: company,
          component: () => import("./views/pages/default.vue"),
        },
        {
          path: "downloads",
          children: downloads,
          component: () => import("./views/pages/default.vue"),
        },
        {
          path: "rules",
          children: rules,
          component: () => import("./views/pages/default.vue"),
        },
        {
          path: "rg",
          children: responsibleGaming,
          component: () => import("./views/pages/default.vue"),
        },
        {
          path: "login",
          name: "Login",
          component: () => import("./views/pages/login.vue"),
          beforeEnter: function(to, from, next) {
            const auth = localStorage.getItem("auth");
            // if Agent
            if (Vue.prototype.$isAgent()) {
              const db_name = store.state.operators.db_name;
              const operator_auth = localStorage.getItem("operator_auth");

              if (auth === "true" && db_name === operator_auth) {
                next({
                  name: "main",
                });
              }

              if (auth === "true" && db_name != operator_auth) {
                Vue.prototype.$logout();
              }

              if (auth === "false" && db_name == undefined) {
                next();
                return;
              }

              if (auth === "false" && db_name != operator_auth) {
                Vue.prototype.$logout();
              }

              if (auth === "false" && db_name === operator_auth) {
                next();
              }

              next();
            }

            // if User
            if (auth === "true") {
              next({
                name: "main",
              });
            } else {
              next();
            }
          },
          children: [
            {
              path: "auth/:operator",
              name: "LoginAgent",
            },
          ],
        },
      ],
    },

    // Dashboard User
    {
      path: "/dashboard",
      component: () => import("./views/dashboard/"),
      meta: {
        requiresAuth: true,
      },
      children: RoutersUser,
      beforeEnter: function(to, from, next) {
        Vue.prototype.$isAgent()
          ? next({
              name: "main",
            })
          : next();
      },
    },

    // Dashboard Agent
    {
      path: "/dashboard",
      component: () => import("./views/dashboard/indexAgent"),
      meta: {
        requiresAuth: true,
      },
      children: RoutersAgent,
      beforeEnter: function(to, from, next) {
        Vue.prototype.$isAgent()
          ? next()
          : next({
              name: "main",
            });
      },
    },

    // Print
    {
      path: "/print",
      name: "Print",
      component: () => import("./views/print/"),
    },

    {
      path: "/promo/:lp_id",
      name: "landingPage",
      component: () => import("./views/landingPage"),
    },

    {
      path: "/404",
      component: () => import("./views/404/"),
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      path: "/access_denied",
      component: () => import("./views/404/access_denied"),
    },
  ],
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

// Antes de entrar em cada rota
router.beforeEach((to, from, next) => {
  const keepQueryParamsRoutes = [
    "DepositSuccessSports",
    "RegisterSuccessSports",
    "BetSuccessSports",
  ];

  if (keepQueryParamsRoutes.includes(to.name) && !hasQueryParams(to)) {
    if (hasQueryParams(from)) {
      next({ name: to.name, query: from.query });
    } else {
      next({ name: to.name, query: { sport: "Futebol", live: "Futebol" } });
    }
  }

  let domain = Vue.prototype.$domain();
  const operator = store.state.operators.operator_name
    ? store.state.operators.operator_name
    : domain.toUpperCase();

  // Nomeando páginas:
  if (
    to.name === "bigTable" ||
    to.name == "DepositSuccessBt" ||
    to.name == "RegisterSuccessBt" ||
    to.name == "BetSuccessBt"
  ) {
    if (operator == "Bet Da Sorte") {
      document.title = `${operator} | Site Oficial | Deposite e Ganhe 100% de Bônus`;
      document.querySelector(
        'meta[name="Description"]'
      ).content = `${operator} - Plataforma online com jogos de cassino e apostas esportivas. Registre-se agora e ganhe seu bônus`;
    } else {
      document.title = `${operator} - Apostas Esportivas Online, Futebol e Ao vivo.`;
    }
  }
  if (
    to.name === "Sports" ||
    to.name == "DepositSuccessSports" ||
    to.name == "RegisterSuccessSports" ||
    to.name == "BetSuccessSports"
  )
    if (operator == "Bet Da Sorte") {
      document.title = `${operator} | Site Oficial | Deposite e Ganhe 100% de Bônus`;
      document.querySelector(
        'meta[name="Description"]'
      ).content = `${operator} - Plataforma online com jogos de cassino e apostas esportivas. Registre-se agora e ganhe seu bônus`;
    } else {
      document.title = `${operator} - Apostas Esportivas Online, Futebol e Ao vivo.`;
    }
  if (to.name === "live")
    document.title = `${operator} - Apostas Esportivas Ao-vivo em Futebol.`;
  if (to.name === "special")
    document.title = `${to.query.category} - Apostas Esportivas Online com ${operator}.`;
  if (to.name === "category")
    document.title = `${to.query.category} - Apostas Esportivas Online com ${operator}.`;
  if (to.name === "tournament")
    document.title = `${to.query.tournament} - ${to.query.category} - Apostas Esportivas Por ${operator}`;
  if (to.name === "eventsLive")
    document.title = `${to.query.event} (Ao vivo) - Apostar com ${operator}.`;
  if (to.params.event || to.query.liveEvent == "false")
    document.title = `${to.query.event} - Apostar com ${operator}.`;
  if (to.matched[0].path === "/page")
    document.title = `${to.name} - ${operator}.`;
  if (to.matched[0].path === "/dashboard")
    if (to.name === "MyPromotions") {
      let currPage = myPromotionsTranslation[lang || "pt"];
      document.title = `${currPage} - Dashboard ${operator}.`;
    } else {
      document.title = `${to.name} - Dashboard ${operator}.`;
    }
  if (to.name === "register-sms") document.title = `Cadastro - ${operator}.`;
  if (to.name === "casinoLobby" && to.params.casinoType === "casino")
    document.title = `Cassino - ${operator}`;
  if (to.name === "casinoLobby" && to.params.casinoType === "live")
    document.title = `Cassino Ao vivo - ${operator}`;
  if (to.name === "casino-game")
    document.title = `Jogar no Cassino - ${operator}.`;

  if (to.name === "AllPromotions") {
    let currPage = promotionsTranslation[lang || "pt"];
    document.title = `${currPage} - ${operator} - Apostas Esportivas Online, Futebol e Ao Vivo`;
  }

  if (to.name === "terms") {
    document.title = `${messages[lang].terms} - Apostas Esportivas Online, Futebol e Ao Vivo`;
  }

  if (to.name === "privacy") {
    document.title = `${messages[lang].privacy} - Apostas Esportivas Online, Futebol e Ao Vivo`;
  }

  if (to.name === "responsibleGamingDoc") {
    document.title = `${messages[lang].responsibleGaming} - Apostas Esportivas Online, Futebol e Ao Vivo`;
  }

  if (to.name === "appClient") {
    document.title = `${messages[lang].appClient} - Apostas Esportivas Online, Futebol e Ao Vivo`;
  }

  if (to.name === "appAgent") {
    document.title = `${messages[lang].appAgent} - Apostas Esportivas Online, Futebol e Ao Vivo`;
  }

  // Tratamento APK (Facilitar Download):
  if (to.name === "apk") {
    next({
      name: "Download App Agente",
    });
  }

  // Mount Ticket Bet by Share
  if (to.name == "BetCreationFromId") {
    const bet = to.params.bet_id;
    var setRoute;
    if (permissions().bigTable) {
      setRoute = { name: "bigTable", query: { bet_id: bet } };
    } else {
      setRoute = {
        name: "Sports",
        query: { sport: "Futebol", live: "Futebol", bet_id: bet },
      };
    }

    next(setRoute);
  }

  if (to.name == "OpenRegisterDialog") {
    let route = {};

    if (permissions().bigTable) {
      route = { name: "bigTable" };
    } else {
      route = {
        name: "Sports",
        query: { sport: "Futebol", live: "Futebol" },
      };
    }

    route.query.open_register = true;

    next(route);
  }

  if (to.name == "p4fresponse") {
    let motive = "";

    if (to.query.motive) {
      motive = to.query.motive;
      localStorage.setItem("p4fmotive", motive);
    }

    let route = {};

    if (permissions().bigTable) {
      route = { name: "bigTable", query: { motive } };
    } else {
      route = {
        name: "Sports",
        query: {
          sport: "Futebol",
          live: "Futebol",
          motive,
        },
      };
    }

    next(route);
  }

  // Open Dialog Deposit
  if (to.name == "depositDialog") {
    let route = {};

    if (permissions().bigTable) {
      route = { name: "bigTable", query: { open_dialog_deposit: true } };
    } else {
      route = {
        name: "Sports",
        query: { sport: "Futebol", live: "Futebol", open_dialog_deposit: true },
      };
    }

    next(route);
  }

  // Tratamento Conferênca (para manter URLs da antiga plataforma):
  if (to.name === "SportsConf") {
    next({
      name: permissions().bigTable ? "bigTable" : "Sports",
      query: {
        sport: "Futebol",
        live: "Futebol",
        conf: to.params.idbet,
      },
    });
  }

  // Tratamento para páginas Antigas Indexadas no Google
  if ("redirectedFrom" in to) {
    // console.log("redirectedFrom", to);

    if (to.redirectedFrom === "/home/about")
      next({
        name: "Sobre",
        query: {
          action: "post",
          params: "main/about",
        },
      });
    if (to.redirectedFrom === "/home/regulation")
      next({
        name: "Regulamento",
        query: {
          action: "post",
          params: "main/regulation",
        },
      });
    if (to.redirectedFrom === "/home/help")
      next({
        name: "Regras",
        query: {
          action: "post",
          params: "main/help",
        },
      });
    if (to.redirectedFrom === "/home/carees")
      next({
        name: "Trabalhe conosco",
        query: {
          email: store.state.operators.contact_email,
        },
      });
    if (to.redirectedFrom === "/apk")
      next({
        name: "Sports",
        query: {
          sport: "Futebol",
          live: "Futebol",
        },
      });
    if (to.redirectedFrom === "/table/visitor") next({ name: "bigTable" });
  }

  // Coloque o "meta: { requiresAuth: true }" para navegações Autenticadas após o Login (Ex. Dashboard).
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const auth = localStorage.getItem("auth");
    const isAuth = auth === "true";
    if (isAuth) {
      next();
    } else {
      if (Vue.prototype.$isAgent()) {
        next({
          path: `/page/login/auth/${domain}`,
          query: {
            redirect: to.fullPath,
          },
        });
      } else {
        next({
          path: "/page/login",
          query: {
            redirect: to.fullPath,
          },
        });
      }
    }
  }

  if (to.name === "Register") {
    document.title = `Cadastro - Apostar com ${operator}`;
  }

  if (to.name === "RegisterSuccessPage") {
    document.title = `Registrado com Sucesso - Apostar com ${operator}`;
  }

  // Verificacao se exite o infotable
  const { markets, logged } = store.state;
  if (markets.length == 0 && logged.status) {
    getInfoTable(true);
  }
  next();
});

// https://router.vuejs.org/guide/advanced/navigation-guards.html#global-after-hooks
router.afterEach((to, from) => {
  // console.log('_______________________');
  // console.log('router.afterEach');
  // console.log(to);
  // console.log(from);
  // console.log('_______________________');

  // ===============================================//
  // Register Event "Cassino" "view_item_list, select_content" to Analytics
  // ===============================================//
  const view_item_list_casino = ["casino", "liveCasino"];
  if (view_item_list_casino.includes(to.name)) {
    // Tratando o Id e Name da Lista;
    var item_list_id, item_list_name, item_category;
    switch (to.name) {
      case "casino":
        item_list_id = "casino";
        item_list_name = "casino";
        item_category = "slots";
        break;
      case "liveCasino":
        item_list_id = "liveCasino";
        item_list_name = "liveCasino";
        item_category = "live";
        break;
      default:
        break;
    }
    // view_item_list
    Vue.prototype.$gtag.view_item_list_casino({
      item_list_id,
      item_list_name,
      item_id: item_list_id,
      item_name: item_list_name,
      item_category,
    });
    // select_content
    Vue.prototype.$gtag.select_content(item_list_name, item_list_id);
  }

  // ===============================================//
  // Register Events "Cassino" "select_item, select_content" to Analytics
  // ===============================================//
  const select_item_casino = ["casino-game"];

  if (select_item_casino.includes(to.name)) {
    // Tratando o Id e Name da Lista;
    var item_list_id = to.params.gameID,
      item_list_name = "casino-game",
      item_category = to.params.gameID;

    // select_item
    Vue.prototype.$gtag.select_item_casino({
      item_list_id,
      item_list_name,
      item_id: item_list_id,
      item_name: item_list_name,
      item_category,
    });

    // select_content
    Vue.prototype.$gtag.select_content(item_list_name, item_list_id);
  }

  // ===============================================//
  // Register Event "Sports" view_item_list, select_content" to Analytics
  // ===============================================//
  const view_item_list = ["category", "countries", "tournament", "live"];
  if (view_item_list.includes(to.name)) {
    // Tratando o Id e Name da Lista;
    var item_list_id,
      item_list_name,
      item_category = to.query.sport,
      item_category2 = "pre-match";
    switch (to.name) {
      case "category":
      case "countries":
        item_list_id = to.params.category;
        item_list_name = to.query.category;
        break;
      case "tournament":
        item_list_id = to.params.tournament;
        item_list_name = to.query.tournament;
        break;
      case "live":
        item_list_id = "live";
        item_list_name = "live";
        item_category = to.query.live;
        item_category2 = "live";
        break;
      default:
        break;
    }
    // view_item_list
    Vue.prototype.$gtag.view_item_list({
      id_sport: to.params.sport,
      item_list_id,
      item_list_name,
      item_id: item_list_id,
      item_name: item_list_name,
      item_category,
      item_category2,
    });
    // select_content
    Vue.prototype.$gtag.select_content(item_list_name, item_list_id);
  }

  // ===============================================//
  // Register Events "select_item, select_content" to Analytics
  // ===============================================//
  const select_item = [
    "btEvent",
    "eventsLive",
    "eventsTournament",
    "eventsCategory",
    "eventsCountries",
  ];

  if (select_item.includes(to.name)) {
    // Tratando o Id e Name da Lista;
    var item_list_id,
      item_list_name,
      item_category = to.query.sport,
      item_category2 = to.query.category,
      item_category3 = to.query.tournament,
      item_category4 = "pre-match";
    switch (to.name) {
      case "btEvent":
        item_list_id = "bt";
        item_list_name = "bigTable";
        break;
      case "eventsCategory":
      case "eventsCountries":
        item_list_id = to.params.category;
        item_list_name = to.query.category;
        break;
      case "eventsTournament":
        item_list_id = to.params.tournament;
        item_list_name = to.query.tournament;
        break;
      case "eventsLive":
        item_list_id = "live";
        item_list_name = "live";
        item_category = to.query.live;
        item_category4 = "live";
        break;
      default:
        break;
    }

    // select_item
    Vue.prototype.$gtag.select_item({
      id_sport: to.params.sport,
      item_list_id,
      item_list_name,
      item_id: to.params.event,
      item_name: to.query.event,
      item_category,
      item_category2,
      item_category3,
      item_category4,
    });

    // select_content
    Vue.prototype.$gtag.select_content(to.query.event, to.params.event);
  }
});

export default router;
